import { AnimatePresence } from 'motion/react';
import { type FC, type ReactNode } from 'react';
import { Routes, useLocation } from 'react-router-dom';

interface AnimatedRoutesProps {
    children: ReactNode;
}

export const AnimatedRoutes: FC<AnimatedRoutesProps> = ({ children }) => {
    const location = useLocation();

    return (
        <AnimatePresence mode="popLayout" initial={false}>
            <Routes location={location} key={location.pathname}>
                {children}
            </Routes>
        </AnimatePresence>
    );
};
